import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import React from "react";

interface WaypointArrivalModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const WaypointArrivalModal: React.FC<WaypointArrivalModalProps> = ({ isOpen, onClose }) => {
    // If on DAMN page then display this string. Otherwise on logistics page.
    const exitString = window.location.href.includes("/event/") ? "delivery" : "location";

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className="bg-plot-blue text-white" id="alert-dialog-title">
                You have arrived at your destination!
            </DialogTitle>
            <DialogContent className="mt-2 flex flex-col gap-4">
                <DialogContentText>Click 'Exit' to return to {exitString} details.</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Exit</Button>
            </DialogActions>
        </Dialog>
    );
};

export default WaypointArrivalModal;
